const cookieBannerHandler = () => {
  const cookieBanner = document.querySelector('[data-cookie]');
  const btn = cookieBanner?.querySelector('[data-cookie="button"]');

  const hasCookie = () => document.cookie.split('; ').some(row => row.startsWith('warned='));

  if (cookieBanner && btn && !hasCookie()) {
    cookieBanner.classList.add('is-open');

    btn.addEventListener('click', () => {
      document.cookie = 'warned=true; max-age=31536000; path=/';
      cookieBanner.classList.remove('is-open');
    });
  }
};

export { cookieBannerHandler };
